import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { locations, GLOBAL_PHONE } from '../data/locations';
export function Footer() {
  const navItems = [{
    label: 'Home',
    path: '/'
  }, {
    label: 'Programs',
    path: '/programs'
  }, {
    label: 'Locations',
    path: '/locations'
  }, {
    label: 'Instructors',
    path: '/instructors'
  }, {
    label: 'Merch',
    path: '/merch'
  }, {
    label: 'Forms & Videos',
    path: '/forms-videos'
  }, {
    label: 'FAQs',
    path: '/faqs'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  return <footer className="bg-[#1a2332] text-white py-12 border-t border-slate-800" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12" data-id="element-162">
          {/* Brand & Contact */}
          <div className="text-center lg:text-left" data-id="element-163">
            <Link to="/" data-id="element-164">
              <img src="https://cdn.magicpatterns.com/uploads/dQfRxPekJeyt5ZDxn6mVmW/bootlogo_copy.png" alt="Che Ko Martial Arts" className="h-20 w-auto mb-4 mx-auto lg:mx-0" data-id="element-165" />
            </Link>
            <p className="text-slate-400 text-sm mb-4" data-id="element-166">
              Professional martial arts training for the whole family.
            </p>

            <div className="space-y-2 text-sm" data-id="element-167">
              <div className="flex items-center justify-center lg:justify-start text-slate-300" data-id="element-168">
                <Phone className="h-4 w-4 mr-2" data-id="element-169" />
                <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="hover:text-white transition-colors" data-id="element-170">
                  {GLOBAL_PHONE}
                </a>
              </div>
            </div>
          </div>

          {/* Locations */}
          <div className="lg:col-span-2" data-id="element-171">
            <h3 className="text-lg font-bold text-white mb-4 text-center lg:text-left" data-id="element-172">
              Our Locations
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-173">
              {locations.map(location => <Link key={location.id} to={`/locations/${location.id}`} className="bg-slate-800/50 hover:bg-slate-700 border border-slate-700 rounded-lg px-4 py-3 text-center transition-colors" data-id="element-174">
                  <div className="flex items-center justify-center mb-1" data-id="element-175">
                    <MapPin className="h-4 w-4 text-[#dc2626] mr-2" data-id="element-176" />
                    <span className="text-sm font-medium text-white" data-id="element-177">
                      {location.city}
                    </span>
                  </div>
                </Link>)}
            </div>

            {/* Navigation */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-2" data-id="element-178">
              {navItems.map(item => <Link key={item.path} to={item.path} className="text-sm text-slate-300 hover:text-white transition-colors" data-id="element-179">
                  {item.label}
                </Link>)}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-center" data-id="element-180">
          <p className="text-slate-500 text-sm" data-id="element-181">
            &copy; {new Date().getFullYear()} Che Ko Martial Arts. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}